module.exports = __webpack_public_path__ + "static/media/pause_sfx.01c131f8.wav";